const collaborationStyle = {
	collaboration: { paddingBlock: { md: "100px", xs: "40px" } },
	collaboration__desc: { textAlign: "center", width: { md: "60%", xs: "100%" }, display: "block", marginInline: "auto", lineHeight: "25px", opacity: "0.7", marginBottom: { xs: "30px", md: "0" } },
	collaboration__pros: { justifyContent: "center", gap: "24px", marginTop: "40px", alignItems: "center" },
};

export default collaborationStyle;
